// extracted by mini-css-extract-plugin
export var cardHeader = "_uf-0";
export var reorderHandle = "_uf-3";
export var titleArea = "_uf-1";
export var titleAreaWithHandle = "_uf-2";